import IAddinEditorPlugin from 'owa-editor-addin-plugin-types/lib/PluginInterface/IAddinEditorPlugin';
import IContentOperationPlugin from './pluginInterfaces/IContentOperationPlugin';
import { LazyLinkPlugin } from 'owa-editor-link-plugin';
import { LazyCortanaPickerPlugin } from 'owa-cortana-compose';
import { LazyAccCheckerPlugin } from 'owa-editor-acc-checker-plugin';
import { LazyAugLoopPlugin } from 'owa-editor-augloop-plugin';
import { LazyDictationPlugin } from 'owa-editor-dictation-plugin';
import { DockingPluginBase } from 'owa-editor-docking-plugin';
import { LazyEmojiPickerPlugin } from 'owa-editor-emoji-picker-plugin';
import { LazyKeyStrokeCounterPlugin } from 'owa-editor-keystroke-counter-plugin';
import { LazyAtMentionsPickerPlugin } from 'owa-editor-mentions-picker-plugin';
import { EditorOperationPlugin } from 'owa-editor-operation-plugin';
import { LazyPasteOptionPlugin } from 'owa-editor-paste-option-plugin';
import { RibbonPlugin } from 'owa-editor-ribbonplugin';
import { LazySmartSuggestionsPlugin } from 'owa-editor-smart-suggestions-plugin';
import { LazySmartComposePlugin } from 'owa-editor-smartcompose-plugin';
import { LazyTableEditPlugin } from 'owa-editor-table-edit-plugin';
import { InlineImagePlugin, LazyInlineImageResizePlugin } from 'owa-inline-image';
import { LazyLinkPreviewPlugin } from 'owa-link-preview-compose';
import { LazyPraguePlugin } from 'owa-prague-integrations';
import { LazyForgottenAttachmentsPlugin } from 'owa-editor-forgotten-attachments-plugin';

// Full list of editor plugins used by Mail and Calendar
// To exclude a plugin from Mail or Calendar, add to ExcludedPluginsForMail or ExcludedPluginsForCalendar

export const orderedEditorPlugins = {
    docking: <DockingPluginBase>null,
    dictation: <LazyDictationPlugin>null,
    ribbon: <RibbonPlugin>null,
    inlineImage: <InlineImagePlugin>null,
    inlineImageResize: <LazyInlineImageResizePlugin>null,
    contentOperation: <IContentOperationPlugin>null,
    tableEdit: <LazyTableEditPlugin>null,
    smartSuggestions: <LazySmartSuggestionsPlugin>null,
    linkPreview: <LazyLinkPreviewPlugin>null,
    addin: <IAddinEditorPlugin>null,
    accChecker: <LazyAccCheckerPlugin>null,
    pasteOption: <LazyPasteOptionPlugin>null,
    link: <LazyLinkPlugin>null,
    mentionsPicker: <LazyAtMentionsPickerPlugin>null,
    cortanaCompose: <LazyCortanaPickerPlugin>null,
    emojiPicker: <LazyEmojiPickerPlugin>null,
    smartCompose: <LazySmartComposePlugin>null,
    prague: <LazyPraguePlugin>null,
    augLoop: <LazyAugLoopPlugin>null,
    editorOperation: <EditorOperationPlugin>null,
    keyStrokeCounter: <LazyKeyStrokeCounterPlugin>null,
    forgottenAttachments: <LazyForgottenAttachmentsPlugin>null,
};

export type PluginKey = keyof typeof orderedEditorPlugins;

type IEditorPlugins = { [K in PluginKey]: (typeof orderedEditorPlugins)[K] };

export default IEditorPlugins;
